// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2jY8I","header":"ReportDetails_header__SmR4a","title":"ReportDetails_title__2V60U","left":"ReportDetails_left__3Q6YA"};